'use strict';

define('counter-module-percentage',['jquery', 'snap.svg'], function ($) {

  // Use the snap.svg plugin to animate svg path according to percentage
  var $counterItems = $('.counter-module-percentage'),
      canvasSize = 230,
      centre = canvasSize/2,
      radius = canvasSize*0.8/2,
      s,
      path = '',
      arc,
      startY = centre-radius;

  var
    local_opts = {
      animation_duration: 1000
    };


  var initialize = function() {
    // If counter item exists
    if ($counterItems.length) {
      $counterItems.each(function() {
        attachEvents($(this));
      });
    }
  };


  var attachEvents = function($this) {
    // Init animation when module waypoint is reached
    $this.waypoint(function() {
      animatePercentage($this);
    }, {
      offset: '85%',
      triggerOnce: true
    });
  };

  var animatePercentage = function($this){
    var percent = $this.find(".counter-module-percentage__input").val(),
        svg = $this.find(".counter-module-percentage__svg").get(0),
        endpoint = (percent/100)*359.99,
        s = Snap(svg),
        arc = s.path(path);

    Snap.animate(0, endpoint, function (val) {
      arc.remove();

      var d = val,
          dr = d-90,
          radians = Math.PI*(dr)/180,
          endx = centre + radius*Math.cos(radians),
          endy = centre + radius * Math.sin(radians),
          largeArc = d>180 ? 1 : 0,
          path = 'M'+centre+','+startY+' A'+radius+','+radius+' 0 '+largeArc+',1 '+endx+','+endy;

      arc = s.path(path);
      $this.find(".counter-module-percentage__percentage").html(Math.round(val/360*100) +'%');
    }, local_opts.animation_duration, mina.easeinout);
  };

  return {
    init: initialize
  };
});
